// // import React, { useState } from 'react';
// // import { HiMenuAlt4, HiX } from 'react-icons/hi';
// // import { motion } from 'framer-motion';
// import React, { useState, useEffect } from 'react';
// import { HiMenuAlt4, HiX } from 'react-icons/hi';
// import { motion, AnimatePresence } from 'framer-motion';
// import Papa from 'papaparse';


// import { images } from '../../constants';
// import './Navbar.scss';

// const Navbar = () => {
// const [toggle, setToggle] = useState(false);
// const [showBanner, setShowBanner] = useState(true);
// const [latestProject, setLatestProject] = useState(null);

// /* second version of project hightlight, blinking, disappear in 60secs */
// // useEffect(() => {
// //   const timer = setTimeout(() => {
// //     setShowBanner(false);
// //   }, 60000); // 60 seconds

// //   return () => clearTimeout(timer);
// // }, []);


// /* third version of project hightlight, 2nd version + csv from local */
// // useEffect(() => {
// //   // Auto hide after 60s
// //   const timer = setTimeout(() => {
// //     setShowBanner(false);
// //   }, 60000);

// //   // Fetch CSV
// //   fetch('/projects.csv')
// //     .then((response) => response.text())
// //     .then((csvText) => {
// //       const parsed = Papa.parse(csvText, {
// //         header: true,
// //         skipEmptyLines: true,
// //       });

// //       const rows = parsed.data;

// //       if (rows.length > 0) {
// //         const lastRow = rows[rows.length - 1];
// //         setLatestProject(lastRow);
// //       }
// //     });
// //   return () => clearTimeout(timer);
// // }, []);

// //forth version of project highlight, 3rd version with csv from URL
// useEffect(() => {
//   const timer = setTimeout(() => {
//     setShowBanner(false);
//   }, 60000);

//   const CSV_URL = "https://raw.githubusercontent.com/deka1105/Portfolio/refs/heads/main/projects.csv"; // <-- replace with your real URL

//   fetch(CSV_URL)
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error("Failed to fetch CSV");
//       }
//       return response.text();
//     })
//     .then((csvText) => {
//       const parsed = Papa.parse(csvText, {
//         header: true,
//         skipEmptyLines: true,
//       });

//       const rows = parsed.data;

//       if (rows.length > 0) {
//         const lastRow = rows[rows.length - 1];
//         setLatestProject(lastRow);
//       }
//     })
//     .catch((error) => {
//       console.error("CSV Fetch Error:", error);
//     });

//   return () => clearTimeout(timer);
// }, []);

//   return (
//     <>
//     {/* first version of project highlight */}
//     {/* <div className="app__top-banner">
//       🚀 New Project Launched! 
//       <a 
//         href="https://github.com" 
//         target="_blank" 
//         rel="noopener noreferrer"
//       >
//         View Here
//       </a>
//     </div> */}

//       {/* second version of project hightlight, blinking, disappear in 60secs */}
// {/*   
//   <AnimatePresence>
//     {showBanner && (
//       <motion.div
//         className="app__top-banner"
//         initial={{ y: -80, opacity: 0 }}
//         animate={{ y: 0, opacity: 1 }}
//         exit={{ y: -80, opacity: 0 }}
//         transition={{ duration: 0.6, ease: 'easeOut' }}
//       >
//         <div className="banner-content">
//           <span className="new-badge">NEW</span>
//           <span className="banner-text">
//             🚀 New Project Launched!
//           </span>
//           <a
//             href="https://yourprojectlink.com"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             View Here
//           </a>
//         </div>

//         <HiX
//           className="banner-close"
//           onClick={() => setShowBanner(false)}
//         />
//       </motion.div>
//     )}
//   </AnimatePresence> */}
//   <AnimatePresence>
//   {showBanner && latestProject && (
//     <motion.div
//       className="app__top-banner"
//       initial={{ y: -80, opacity: 0 }}
//       animate={{ y: 0, opacity: 1 }}
//       exit={{ y: -80, opacity: 0 }}
//       transition={{ duration: 0.6 }}
//     >
//       <div className="banner-content">
//         <span className="new-badge">NEW</span>

//         <span className="banner-text">
//           🚀 {latestProject.project_name}
//         </span>

//         <a
//           href={latestProject.project_link}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           View Here
//         </a>
//       </div>

//       <HiX
//         className="banner-close"
//         onClick={() => setShowBanner(false)}
//       />
//     </motion.div>
//   )}
// </AnimatePresence>

//   <nav className="app__navbar"></nav>

//     <nav className="app__navbar">
//       <div className="app__navbar-logo">
//         <img src={images.logo} alt="logo" />
//       </div>
//       <ul className="app__navbar-links">
//         {['home', 'about', 'skills', 'work', 'contact', 'resume'].map((item) => (
//           // <li className="app__flex p-text" key={`link-${item}`}>
//           //   <div />
//           //   <a href={`#${item}`}>{item}</a>
//           // </li>
//           <li className="app__flex p-text" key={`link-${item}`}>
//             <div />
//             {item === 'resume' ? (
//               <a href="./resume.pdf" download="Shubham_Dekate_Resume.pdf">
//                 {item}
//               </a>
//             ) : (
//               <a href={`#${item}`}>{item}</a>
//             )}
//           </li>
//         ))}
//       </ul>

//       <div className="app__navbar-menu">
//         <HiMenuAlt4 onClick={() => setToggle(true)} />

//         {toggle && (
//           <motion.div
//             whileInView={{ x: [300, 0] }}
//             transition={{ duration: 0.85, ease: 'easeOut' }}
//           >
//             <HiX onClick={() => setToggle(false)} />
//             {/* <ul>
//               {['home', 'about', 'skills', 'work', 'contact', 'resume'].map((item) => (
//                 <li key={item}>
//                   <a href={`#${item}`} onClick={() => setToggle(false)}>
//                     {item}
//                   </a>
//                 </li>
                
//               ))}
//             </ul>
//              */}
//             <ul>
//               {['home', 'about', 'skills', 'work', 'contact', 'resume'].map((item) => (
//                 <li key={item}>
//                   {item === 'resume' ? (
//                     <a
//                       href="/resume.pdf"
//                       download="Shubham_Dekate_Resume.pdf"
//                       onClick={() => setToggle(false)}
//                     >
//                       {item}
//                     </a>
//                   ) : (
//                     <a
//                       href={`#${item}`}
//                       onClick={() => setToggle(false)}
//                     >
//                       {item}
//                     </a>
//                   )}
//                 </li>
//               ))}
//             </ul>

//           </motion.div>
//         )}
//       </div>
//     </nav>
//     </>
//   );
// };

// export default Navbar;



import React, { useState, useEffect } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion, AnimatePresence } from 'framer-motion';
import Papa from 'papaparse';

import { images } from '../../constants';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const [showBanner, setShowBanner] = useState(true);
  const [latestProject, setLatestProject] = useState(null);
  const [resumeDownloaded, setResumeDownloaded] = useState(false);

  // ✅ Resume download tracking + confirmation
  const handleResumeDownload = () => {
    // Send GA4 event
    if (window.gtag) {
      window.gtag('event', 'resume_download', {
        event_category: 'engagement',
        event_label: 'Navbar Resume Download',
      });
    }

    setResumeDownloaded(true);

    // Reset text after 3 seconds
    setTimeout(() => {
      setResumeDownloaded(false);
    }, 3000);
  };

  // CSV fetch for latest project banner
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(false);
    }, 60000);

    const CSV_URL =
      "https://raw.githubusercontent.com/deka1105/Portfolio/refs/heads/main/projects.csv";

    fetch(CSV_URL)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch CSV");
        }
        return response.text();
      })
      .then((csvText) => {
        const parsed = Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
        });

        const rows = parsed.data;

        if (rows.length > 0) {
          const lastRow = rows[rows.length - 1];
          setLatestProject(lastRow);
        }
      })
      .catch((error) => {
        console.error("CSV Fetch Error:", error);
      });

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* Project Highlight Banner */}
      <AnimatePresence>
        {showBanner && latestProject && (
          <motion.div
            className="app__top-banner"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: -80, opacity: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="banner-content">
              <span className="new-badge">NEW</span>

              <span className="banner-text">
                🚀 {latestProject.project_name}
              </span>

              <a
                href={latestProject.project_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                View Here
              </a>
            </div>

            <HiX
              className="banner-close"
              onClick={() => setShowBanner(false)}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <nav className="app__navbar"></nav>

      <nav className="app__navbar">
        <div className="app__navbar-logo">
          <img src={images.logo} alt="logo" />
        </div>

        {/* Desktop Links */}
        <ul className="app__navbar-links">
          {['home', 'about', 'skills', 'work', 'contact', 'resume'].map(
            (item) => (
              <li className="app__flex p-text" key={`link-${item}`}>
                <div />

                {item === 'resume' ? (
                  <motion.a
                    href="./resume.pdf"
                    download="Shubham_Dekate_Resume.pdf"
                    onClick={handleResumeDownload}
                    whileTap={{ scale: 0.9 }}
                    animate={
                      resumeDownloaded
                        ? { scale: [1, 1.2, 1] }
                        : { scale: 1 }
                    }
                    transition={{ duration: 0.4 }}
                  >
                    {resumeDownloaded ? "Downloaded ✓" : item}
                  </motion.a>
                ) : (
                  <a href={`#${item}`}>{item}</a>
                )}
              </li>
            )
          )}
        </ul>

        {/* Mobile Menu */}
        <div className="app__navbar-menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />

          {toggle && (
            <motion.div
              whileInView={{ x: [300, 0] }}
              transition={{ duration: 0.85, ease: 'easeOut' }}
            >
              <HiX onClick={() => setToggle(false)} />

              <ul>
                {[
                  'home',
                  'about',
                  'skills',
                  'work',
                  'contact',
                  'resume',
                ].map((item) => (
                  <li key={item}>
                    {item === 'resume' ? (
                      <motion.a
                        href="./resume.pdf"
                        download="Shubham_Dekate_Resume.pdf"
                        onClick={() => {
                          handleResumeDownload();
                          setToggle(false);
                        }}
                        whileTap={{ scale: 0.9 }}
                        animate={
                          resumeDownloaded
                            ? { scale: [1, 1.2, 1] }
                            : { scale: 1 }
                        }
                        transition={{ duration: 0.4 }}
                      >
                        {resumeDownloaded ? "Downloaded ✓" : item}
                      </motion.a>
                    ) : (
                      <a
                        href={`#${item}`}
                        onClick={() => setToggle(false)}
                      >
                        {item}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navbar;